import { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import style from './style';

type Props = {
  icon?: ReactNode;
  text: string,
}

export default function Title({ text, icon }: Props): JSX.Element {
  return (
    <Box sx={ { ...style.box, ...style.boxMain, ...style.gapBox } }>
      <Box sx={ { ...style.box, ...style.gapBox } }>
        { icon }
        <Typography variant={ style.title.variant } >
          { text }
        </Typography>
      </Box>
    </Box>
  );
}

Title.defaultProps = {
  icon: undefined,
};
